import { render, staticRenderFns } from "./TraxTrainingCompetencyIndexCrudTable.vue?vue&type=template&id=4ba0ba44"
import script from "./TraxTrainingCompetencyIndexCrudTable.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCompetencyIndexCrudTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports